<script>
import FormElement from '@wielink-application/shared/vue/components/form/horizontal/pictures.vue'
export default FormElement;
</script>